import React, { useState, useRef, useEffect } from "react";
import LinkCart from "../Components/Home/LinkCart";
import "./building_page.css";
import imgCardDatas from "./imgcard.json";
import { useParams } from "react-router-dom";

export default function ImgBlog() {
  let { slug } = useParams();
  const selectedCard = imgCardDatas.data.filter(
    (imgCardData) => imgCardData.slug === slug
  );
  const datas = imgCardDatas.data.filter(
    (imgCardData) => imgCardData.slug !== slug
  );
  const [isScrolledToSection, setIsScrolledToSection] = useState({
    section1: false,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
  });

  const section1Ref = useRef(null);
  const section2Ref = useRef(null);
  const section3Ref = useRef(null);
  const section4Ref = useRef(null);
  const section5Ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("id");
          if (entry.isIntersecting) {
            switch (id) {
              case "section1":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: false,
                  section3: false,
                  section4: false,
                });
                break;
              case "section2":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: true,
                  section3: false,
                  section4: false,
                });
                break;
              case "section3":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: true,
                  section3: true,
                  section4: false,
                });
                break;
              case "section4":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: true,
                  section3: true,
                  section4: true,
                });
                break;
              case "section5":
                setIsScrolledToSection({
                  section5: true,
                  section1: true,
                  section2: true,
                  section3: true,
                  section4: true,
                });
                break;
              default:
                return;
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    const sections = [
      section1Ref,
      section2Ref,
      section3Ref,
      section4Ref,
      section5Ref,
    ];
    sections.forEach((sectionRef) => {
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
    });

    return () => {
      sections.forEach((sectionRef) => {
        if (sectionRef.current) {
          observer.unobserve(sectionRef.current);
        }
      });
    };
  }, [isScrolledToSection]);
  return (
    <div className="flex flex-col w-full pt-48 bg-white">
      <div className="relative w-full max-w-[1440px] mx-auto gap-12 px-10 md:flex">
        <div
          ref={section5Ref}
          id="section5"
          className="top-[40px] absolute"
        ></div>
        <div className="relative justify-center w-full ease-linear opacity-100 pointer-events-auto  transform-none duration-40">
          <div
            ref={section4Ref}
            id="section4"
            className="absolute top-[240px]"
          ></div>
          <img
            src={selectedCard[0].src}
            title={selectedCard[0].title}
            alt={selectedCard[0].title || ""}
            className={`w-full object-cover ${
              isScrolledToSection.section4
                ? "top-0 opacity-100"
                : "top-[270px] opacity-0"
            } transition-all duration-[500ms] relative`}
          />
        </div>
        <div
          className={`w-full text-base ml-auto relative py-12 ${
            isScrolledToSection.section5
              ? "opacity-100 top-[0px]"
              : "opacity-100 top-[40px]"
          } transition-all duration-[500ms] relative`}
        >
          <p className={"max-w-[980px]  text-lg text-[#b98953]"}>
            {selectedCard[0].name}
          </p>
          <div ref={section1Ref} id="section1"></div>
          <h2 className=" max-w-[980px] text-[#7e6140] mt-3 pb-[12px] text-5xl">
            {selectedCard[0].leading}
          </h2>
          <p className=" max-w-[980px] contrast-[21] mt-[20px] text-lg text-[#00000]">
            {selectedCard[0].description}
          </p>
        </div>
      </div>
      <div className="w-full  pt-0 pb-14 md:py-10 text-[#00000] bg-[rgb(240,237,232)]">
        <section className="w-full block mt-[84px]">
          <div className="relative items-start justify-between w-full gap-10 md:flex">
            <div
              ref={section3Ref}
              id="section3"
              className="absolute top-[60px]"
            ></div>
            <div className="flex justify-between gap-8 md:gap-16 mx-auto md:grid md:grid-cols-3">
              {datas.map((imgCardData, index) => (
                <LinkCart
                  className={`${
                    isScrolledToSection.section3
                      ? "top-0 opacity-100"
                      : "top-[60px] opacity-0"
                  } transition-all duration-[250ms] relative`}
                  img={imgCardData.cardSrc || imgCardData.src}
                  name={imgCardData.name}
                  link={`/neighborhood/${imgCardData.slug}`}
                />
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
